import LocationCardLoader from './LocationCardLoader';

type LocationCardsLoaderProps = {
  dataTestId: string;
};

export default function LocationCardsLoader({
  dataTestId,
}: LocationCardsLoaderProps) {
  return (
    <>
      <ul className="z-[1] flex gap-5">
        <li className="rounded-sm border border-grey-60 mb-5">
          <LocationCardLoader dataTestId={`${dataTestId}-card-1`} />
        </li>
        <li className="rounded-sm border border-grey-60 mb-5">
          <LocationCardLoader dataTestId={`${dataTestId}-card-2`} />
        </li>
      </ul>
    </>
  );
}
